export default "__VITE_ASSET__CgNO$uKc__"